import { useEffect, useRef } from 'react';

// Aviso de alteracoes nao salvas. O salvamento continua explicito (decisao de
// projeto): aqui so se pergunta antes de perder o que foi digitado.
//
// Cobre tres saidas:
//   1. fechar/recarregar a aba        -> aviso do proprio navegador (beforeunload)
//   2. clicar em link ou item do menu -> confirm() antes de o React navegar
//   3. botao "Voltar" da tela         -> confirm() antes do history.go(-1)
// O botao Voltar DO NAVEGADOR nao e interceptado (limitacao conhecida).
//
// Uso: const naoSalvo = useAvisoAlteracoes(d);  ...  naoSalvo.limpo() depois de salvar.
// `estado` pode ser o objeto do formulario, uma lista de estados ou uma funcao
// que diz se ha alteracao (antd Form: () => JSON.stringify(form.getFieldsValue(true)) !== base).

const MSG = 'Há alterações não salvas neste formulário. Sair mesmo assim e perder o que foi digitado?';
const verificadores = new Set(); // um por formulario aberto
const algumSujo = () => { for (const v of verificadores) { try { if (v()) return true; } catch (e) { /* ignora */ } } return false; };

let instalado = false;
function instalarGlobais() {
  if (instalado || typeof window === 'undefined') return;
  instalado = true;
  // 2. links e menu: captura no document, antes de o React receber o clique
  document.addEventListener('click', (e) => {
    if (!verificadores.size || !algumSujo()) return;
    const alvo = e.target && e.target.closest && e.target.closest('a[href], .ant-menu-item, .ant-menu-submenu-title');
    if (!alvo) return;
    if (alvo.tagName === 'A' && (alvo.target === '_blank' || /^(mailto:|tel:|https?:\/\/wa\.me)/.test(alvo.getAttribute('href') || ''))) return;
    if (!window.confirm(MSG)) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  // 3. navigate(-1) do react-router passa por window.history.go
  const goOriginal = window.history.go.bind(window.history);
  window.history.go = function (n) {
    if (verificadores.size && algumSujo() && !window.confirm(MSG)) return undefined;
    return goOriginal(n);
  };
}

export default function useAvisoAlteracoes(estado) {
  const base = useRef(null);
  const rebaseAte = useRef(0);
  const sujoRef = useRef(() => false);

  const fn = typeof estado === 'function' ? estado : null;
  let sujo = false;
  if (fn) {
    sujoRef.current = fn; // formulario do antd nao redesenha ao digitar: decide na hora
  } else {
    const principal = Array.isArray(estado) ? estado[0] : estado;
    const carregado = principal && typeof principal === 'object' && Object.keys(principal).length > 0;
    let atual = null;
    if (carregado) {
      try { atual = JSON.stringify(estado); } catch (e) { atual = null; }
    }
    if (atual !== null && (base.current === null || Date.now() < rebaseAte.current)) base.current = atual;
    sujo = atual !== null && base.current !== null && atual !== base.current;
    sujoRef.current = () => sujo;
  }

  // registra este formulario enquanto a tela estiver aberta
  useEffect(() => {
    instalarGlobais();
    const v = () => !!sujoRef.current();
    verificadores.add(v);
    return () => { verificadores.delete(v); };
  }, []);

  // 1. fechar / recarregar a aba
  useEffect(() => {
    const h = (e) => {
      let s = false;
      try { s = !!sujoRef.current(); } catch (err) { s = false; }
      if (!s) return undefined;
      e.preventDefault(); e.returnValue = ''; return '';
    };
    window.addEventListener('beforeunload', h);
    return () => window.removeEventListener('beforeunload', h);
  }, []);

  return {
    sujo,
    limpo: () => { base.current = null; rebaseAte.current = Date.now() + 2000; }
  };
}
